var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSafetyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_1418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09981 16.9999H4.3291V15.5322H5.87027V16.1942L5.09981 16.9999Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1347 16.8905H14.9054V15.4229H13.3643V16.0848L14.1347 16.8905Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1885 15.9824H4.73867C4.45 15.9824 4.21582 15.7485 4.21582 15.4596V3.92958C4.21582 3.64092 4.45 3.40674 4.73867 3.40674H15.1887C15.4774 3.40674 15.7116 3.64092 15.7116 3.92958V15.4596C15.7113 15.7485 15.4774 15.9824 15.1885 15.9824Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.753 14.9112H5.17299C5.11951 14.9112 5.07617 14.8678 5.07617 14.8143V4.57386C5.07617 4.52039 5.11951 4.47705 5.17299 4.47705H14.753C14.8065 4.47705 14.8498 4.52039 14.8498 4.57386V14.8143C14.8498 14.8678 14.8065 14.9112 14.753 14.9112Z",
    fill: "#FFEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4702 16.3867L5.19871 14.9031C5.16221 14.8965 5.13281 14.8473 5.13281 14.7933V4.59517C5.13281 4.54119 5.16221 4.49202 5.19871 4.48543L13.4702 3.00155C13.5305 2.99065 13.5797 3.03855 13.5797 3.1085V16.2798C13.5797 16.3497 13.5308 16.3976 13.4702 16.3867Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2527 9.69426C11.2527 11.3165 10.2144 12.5444 9.01512 12.4443C7.89746 12.3508 7.0459 11.1221 7.0459 9.69426C7.0459 8.26638 7.89771 7.03796 9.01512 6.94419C10.2144 6.84408 11.2527 8.07225 11.2527 9.69426Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7119 9.69431C10.7119 10.9237 9.9313 11.8703 9.01588 11.8113C8.14861 11.7555 7.47852 10.8087 7.47852 9.69431C7.47852 8.57993 8.14861 7.63308 9.01588 7.57733C9.93156 7.51827 10.7119 8.46487 10.7119 9.69431Z",
    fill: "#FFEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58874 9.69376C9.58874 10.1097 9.32948 10.4406 9.01521 10.4338C8.70677 10.427 8.46094 10.0957 8.46094 9.69376C8.46094 9.29181 8.70677 8.96081 9.01521 8.95372C9.32973 8.94687 9.58874 9.27812 9.58874 9.69376Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06117 11.7726C9.06117 11.616 9.06117 11.4591 9.06117 11.3025C9.06117 11.2376 8.98438 11.234 8.98438 11.2987C8.98438 11.455 8.98438 11.6114 8.98438 11.7678C8.98463 11.8324 9.06117 11.8375 9.06117 11.7726Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06117 8.08579C9.06117 7.92916 9.06117 7.77228 9.06117 7.61566C9.06117 7.55078 8.98438 7.55559 8.98438 7.62047C8.98438 7.77684 8.98438 7.93322 8.98438 8.08959C8.98463 8.15421 9.06117 8.15092 9.06117 8.08579Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50838 9.76265C7.61736 9.76214 7.72685 9.76164 7.83734 9.76113C7.88322 9.76088 7.88296 9.66381 7.83709 9.66406C7.72659 9.66482 7.61711 9.66584 7.50813 9.6666C7.46327 9.66685 7.46352 9.7629 7.50838 9.76265Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2863 9.74834C10.4153 9.74783 10.5455 9.74707 10.6766 9.74631C10.7311 9.74606 10.7308 9.64012 10.6761 9.64063C10.545 9.64164 10.415 9.64265 10.2858 9.64367C10.2325 9.64418 10.233 9.74859 10.2863 9.74834Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98275 11.1907C8.06031 11.0846 8.13811 10.9779 8.21642 10.8707C8.24886 10.826 8.19615 10.7564 8.16371 10.801C8.08565 10.9082 8.0081 11.0149 7.9308 11.1211C7.89912 11.1649 7.95082 11.2346 7.98275 11.1907Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91239 8.54782C9.99957 8.42845 10.0873 8.30832 10.1752 8.18769C10.2117 8.1375 10.1524 8.06832 10.1159 8.1185C10.0282 8.23913 9.94077 8.35926 9.85384 8.47863C9.81836 8.5278 9.8764 8.59699 9.91239 8.54782Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98733 8.21373C8.06057 8.3255 8.13407 8.43752 8.20808 8.5503C8.23874 8.59718 8.29425 8.53103 8.26333 8.48415C8.18907 8.37137 8.11532 8.25909 8.04182 8.14758C8.01166 8.1012 7.95717 8.1676 7.98733 8.21373Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8039 10.9839C9.88576 11.1085 9.96788 11.234 10.0508 11.36C10.085 11.4122 10.1471 11.3475 10.1126 11.2951C10.0297 11.1691 9.9471 11.0434 9.86498 10.9187C9.83102 10.8673 9.76994 10.9321 9.8039 10.9839Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3501 12.007L12.3461 12.0068C12.267 12.0017 12.2031 11.9214 12.2031 11.8274V7.65574C12.2031 7.56171 12.267 7.48162 12.3461 7.47655L12.3501 7.4763C12.4294 7.47148 12.4941 7.54422 12.4941 7.63926V11.8446C12.4941 11.9394 12.4294 12.0121 12.3501 12.007Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6816 16.3881H13.4697V3.00146H13.6816C13.71 3.00146 13.7331 3.02453 13.7331 3.05291V16.3367C13.7331 16.3651 13.71 16.3881 13.6816 16.3881Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50493 7.17655V6.47756C5.50493 6.29711 5.3587 6.15088 5.17825 6.15088C4.9978 6.15088 4.85156 6.29711 4.85156 6.47756V7.17655H5.50493Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85156 7.26807V7.96705C4.85156 8.1475 4.9978 8.29374 5.17825 8.29374C5.3587 8.29374 5.50493 8.1475 5.50493 7.96705V7.26807H4.85156Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42388 11.8977V11.1988C5.42388 11.0183 5.27764 10.8721 5.09719 10.8721C4.91674 10.8721 4.77051 11.0183 4.77051 11.1988V11.8977H5.42388Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77051 11.9897V12.6887C4.77051 12.8692 4.91674 13.0154 5.09719 13.0154C5.27764 13.0154 5.42388 12.8692 5.42388 12.6887V11.9897H4.77051Z",
    fill: "#4B4A50"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafetyBox);
export default __webpack_public_path__ + "static/media/icon-safety-box.8fc29e629c484a39687d6e1eeebfe5ec.svg";
export { ForwardRef as ReactComponent };